export const tokenAddresses = {
  EUL: "0x0000000000000000000000000000000000000000",
  rEUL: "0x0000000000000000000000000000000000000000",
}
